module.exports = __webpack_public_path__ + "static/Center-Healthy-Neighborhoods-800x500-4aa78f893bcc12ae6e3e7796b2884701.jpg";